import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export interface TriggerAwInsertRequest {
	triggerFilters: string[];
	updateAttributes?: string[];
}

export const triggerAwInsert = createAppAsyncThunk<void, TriggerAwInsertRequest>(
	"formStep/triggerAwInsert",
	async ({ triggerFilters, updateAttributes }, { getState, dispatch, rejectWithValue, extra }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;

			if (!selectedEtlImportUuid) return rejectWithValue("No selected ETL import");

			await extra.etlClient.trigger(EtlApiTarget.INSERT_DATA_IN_AW_API, selectedEtlImportUuid, { 
				triggerFilters,
				updateAttributes
			});

		} catch (error: any) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	}
);
